var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-toolbar',{attrs:{"dense":""}},[_c('period-selector',{attrs:{"periodType":_vm.period},on:{"periodSelected":_vm.onPeriodSelected}}),_c('v-spacer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }